var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 16C30.25 19.4439 27.4454 22.25 24 22.25C20.5546 22.25 17.75 19.4439 17.75 16C17.75 12.5561 20.5546 9.75 24 9.75C27.4454 9.75 30.25 12.5561 30.25 16Z",
    stroke: "#7939CC",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3321 21.084C41.3321 23.4711 39.3863 25.416 36.9981 25.416C34.6098 25.416 32.6641 23.4711 32.6641 21.084C32.6641 18.6964 34.6104 16.75 36.9981 16.75C39.3857 16.75 41.3321 18.6964 41.3321 21.084Z",
    stroke: "#7939CC",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3321 21.084C15.3321 23.4711 13.3863 25.416 10.9981 25.416C8.60984 25.416 6.66406 23.4711 6.66406 21.084C6.66406 18.6964 8.61042 16.75 10.9981 16.75C13.3857 16.75 15.3321 18.6964 15.3321 21.084Z",
    stroke: "#7939CC",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 36C13.75 30.3385 18.3402 25.75 24 25.75C29.6598 25.75 34.25 30.3385 34.25 36V38C34.25 38.1376 34.1376 38.25 34 38.25H14C13.8624 38.25 13.75 38.1376 13.75 38V36Z",
    stroke: "#7939CC",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 37C3.75 33.5202 6.21589 30.6049 9.49035 29.9082C8.69634 31.7801 8.25 33.8371 8.25 36C8.25 36.7853 8.36995 37.5401 8.58917 38.25H5C4.31236 38.25 3.75 37.6876 3.75 37Z",
    stroke: "#7939CC",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5079 29.9082C41.7824 30.6049 44.2482 33.5202 44.2482 37C44.2482 37.6876 43.6859 38.25 42.9982 38.25H39.4091C39.6283 37.5401 39.7482 36.7853 39.7482 36C39.7482 33.8371 39.3019 31.7801 38.5079 29.9082Z",
    stroke: "#7939CC",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.b3350c162d46c0ce5db19cda5aeb24e2.svg";
export { ForwardRef as ReactComponent };